import {
  ScheduleReminderOffset,
  type ScheduleReminderOffsetValue,
} from '@/shared/types/notification'

export const SCHEDULE_REMINDER_OFFSET_SECONDS: Record<ScheduleReminderOffsetValue, number> = {
  [ScheduleReminderOffset.FIVE_MINUTES]: 5 * 60,
  [ScheduleReminderOffset.ONE_HOUR]: 60 * 60,
}

export const MAX_SCHEDULE_REMINDER_OFFSET_SECONDS = Math.max(
  ...Object.values(SCHEDULE_REMINDER_OFFSET_SECONDS),
)
